import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ResponsiveService} from '../../services/responsive.service';
import {scrollerIds} from '../../constants/scroll.constants';

@Component({
  selector: 'si-go-up-button',
  templateUrl: './go-up-button.component.html',
  styleUrls: ['./go-up-button.component.scss']
})
export class GoUpButtonComponent implements OnInit {
  @Input() icon = 'icon-up';
  @Input() styleClass: string;
  @Input() scrollerId = scrollerIds.CONTAINER;
  @Input() bottom: string;
  @Input() isBottom: boolean;
  @Input() showButtonUp: boolean;
  @Output() isBottomChange = new EventEmitter<any>();
  @Output() showButtonUpChange = new EventEmitter<boolean>();
  @Output() scrollBarChange = new EventEmitter<boolean>();
  @ViewChild('goUpButtonContainer', {static: true}) goUpButtonContainer: ElementRef;
  defaultBottomMobile = '72px';
  defaultBottomTablet = '190px';
  isMobile: boolean;
  scrollContainer: HTMLElement;
  private _itemsLoaded: number;
  private _isBottomChangeEmitted = false;

  constructor(private responsiveService: ResponsiveService) {
  }

  get itemsLoaded() {
    return this._itemsLoaded;
  }

  @Input()
  set itemsLoaded(val) {
    this._itemsLoaded = val;
    if (val) {
      // With a timeout we ensure that the scrollBar is checked after the items have been updated.
      setTimeout(() => {
        this.emitHasScrollBar();
      });
    }
  }

  ngOnInit(): void {
    this.isMobile = this.responsiveService.isMobile();
    this.setBottom();
    this.addScrollEvent();
  }

  setBottom(): void {
    let bottom: string;
    if (this.isMobile) {
      bottom = this.defaultBottomMobile;
    } else {
      bottom = this.defaultBottomTablet;
    }

    if (this.bottom) {
      bottom = this.bottom;
    }

    this.goUpButtonContainer.nativeElement.style.setProperty('--go-up-button-bottom', bottom);
  }

  emitHasScrollBar(): void {
    this.scrollBarChange.emit(this.hasScrollBar());
  }

  hasScrollBar(): boolean {
    return this.scrollContainer && this.scrollContainer?.scrollHeight > this.scrollContainer?.clientHeight;
  }

  addScrollEvent(): void {
    setTimeout(() => {
      this.onScroll = this.onScroll.bind(this);
      this.scrollContainer = document.getElementById(this.scrollerId);
      this.scrollContainer.addEventListener('scroll', this.onScroll);
    });
  }

  onScroll(): void {
    if (this.hasScrollBar() && this.scrollContainer.scrollHeight - Math.ceil(this.scrollContainer.scrollTop) <= this.scrollContainer.clientHeight) {
      if (this._isBottomChangeEmitted) {
        return;
      }

      this._isBottomChangeEmitted = true;
      this.isBottomChange.emit();
      setTimeout(() => {
        this._isBottomChangeEmitted = false;
      }, 500);
    }

    if (this.scrollContainer.scrollTop === 0) {
      this.showButtonUp = false;
      this.showButtonUpChange.emit(false);
    } else if (!this.showButtonUp) {
      this.showButtonUp = true;
      this.showButtonUpChange.emit(true);
    }
  }

  onClickButtonGoUp(event: Event): void {
    event.stopPropagation();
    if (!this.scrollContainer) {
      return;
    }

    this.scrollContainer.scrollTo(0, 0);
  }

  ngOnDestroy(): void {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.onScroll);
    }
  }
}
